import { render, staticRenderFns } from "./eventAccess.vue?vue&type=template&id=d6aad0d8&scoped=true"
import script from "./eventAccess.vue?vue&type=script&lang=js"
export * from "./eventAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6aad0d8",
  null
  
)

export default component.exports